<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Ownership</template>
    <template #trailing>
      <Sheet.Button
        v-if="isOwner"
        variant="primary"
        :icon="SendIcon"
        :disabled="!body?.canSend || !!body?.sendInvitesLoading"
        @click="body?.handleInviteClick()"
      />
    </template>

    <Sheet.Body class="pt-[25px]">
      <FileOwnersBody ref="body" :file="file" hide-send-button />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon, SendIcon } from '@dacr/icons'
import { FileRole } from '@/shared/graphql/router/graphql'
import type { File } from '@/shared/graphql/router/graphql'
import FileOwnersBody from './FileOwnersBody.vue'

const props = defineProps<{
  file: File
}>()

const isOwner = computed(() => props.file.role === FileRole.Owner)

const { close } = useSheet()

const body = ref<{
  handleInviteClick: () => void
  canSend: boolean
  sendInvitesLoading: boolean
} | null>(null)
</script>
